import { Button } from "@miror-ui/components";
import { useScroll } from "shared/hooks/useScroll";

export const ScrollToTarotButton = () => {
  const { scrollTo } = useScroll();

  const handleClick = () => {
    scrollTo("tarot", { behavior: "smooth", offset: -80 });
  };

  return (
    <Button
      onClick={handleClick}
      tw="w-64 h-12 from-grape to-grape mx-auto mt-[22px]"
    >
      カードを選んで結果を見る
    </Button>
  );
};
